import { GetAllUsersInDto, GetAllUsersOutDto } from '../../../types/user.dto'

export const GET_ALL_USERS = 'GET_ALL_USERS'
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS'
export const GET_ALL_USERS_ERROR = 'GET_ALL_USERS_ERROR'
export const RESET_ALL_USERS = 'RESET_USER'

export interface GetAllUsers {
  type: typeof GET_ALL_USERS
  payload: GetAllUsersOutDto
}

export interface GetAllUsersSuccess {
  type: typeof GET_ALL_USERS_SUCCESS
  payload: GetAllUsersInDto
}

export interface GetAllUsersError {
  type: typeof GET_ALL_USERS_ERROR
  payload: boolean | string
}

export interface ResetAllUsers {
  type: typeof RESET_ALL_USERS
  payload: null
}

export interface State {
  data: GetAllUsersInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetAllUsers | GetAllUsersSuccess | GetAllUsersError | ResetAllUsers
